exports.onClientEntry = () => {}
